import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { skills } from '../data/mock';

const Skills = () => {
  return (
    <section id="skills" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light text-black mb-6 tracking-tight">
            Skills & Expertise
          </h2>
          <div className="w-24 h-0.5 bg-black mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Three decades of expertise across engineering, technology leadership, and digital innovation
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {skills.map((skillCategory, index) => (
            <Card 
              key={index} 
              className="border-0 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <CardHeader className="pb-4">
                <CardTitle className="text-xl font-light text-black group-hover:text-gray-700 transition-colors duration-300">
                  {skillCategory.category}
                </CardTitle>
                <div className="w-12 h-0.5 bg-black group-hover:w-full transition-all duration-300"></div>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {skillCategory.items.map((skill, skillIndex) => (
                    <Badge 
                      key={skillIndex}
                      variant="outline" 
                      className="mr-2 mb-2 text-gray-700 border-gray-300 hover:border-black hover:text-black transition-colors duration-200"
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom Statistics */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="space-y-2">
            <div className="text-4xl font-light text-black">30+</div>
            <div className="text-gray-600">Years Experience</div>
          </div>
          <div className="space-y-2">
            <div className="text-4xl font-light text-black">100M+</div>
            <div className="text-gray-600">Identity Records Managed</div>
          </div>
          <div className="space-y-2">
            <div className="text-4xl font-light text-black">$433M</div>
            <div className="text-gray-600">International Funding Secured</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;